import Vue from "vue";
import * as MUTATIONS from "@/config/constants/mutations-types-bdc";
export default {
  [MUTATIONS.ON_BDC_SET_FILTERS_DATA](state, payload) {
    if (payload && typeof payload === "object") {
      Vue.set(state.bdc, "filtros", {
        categorias: payload.categorias || [],
        merchants: payload.merchants || [],
        tipoProductos: payload.tipoProductos || []
      });
    }
  },
  [MUTATIONS.ON_BDC_SET_CONVENIOS_DATA](state, payload) {
    if (payload && typeof payload === "object") {
      Vue.set(state.bdc, "convenios", {
        data: payload.data || [],
        paginas: payload.paginas || 1,
        registros: payload.registros || 0
      });
    }
  },
  /**
   * Setear datos del error de Agro en el store
   * @param {Object} state
   * @param {Object} payload Datos del error
   */
  [MUTATIONS.SET_AGRO_ERROR]: (state, payload) => {
    Vue.set(state, "agroError", payload);
  },

  /**
   * Limpiar datos del error de Agro
   * @param {Object} state
   */
  [MUTATIONS.CLEAR_AGRO_ERROR]: state => {
    Vue.set(state, "agroError", {
      title: "",
      subtitle: "",
      image: "",
      hasAction: false,
      action: null,
      actionPayload: null,
      returnRoute: null,
      successAction: null,
      tituloMaxIntentos: "",
      subtituloMaxIntentos: ""
    });
  }
};
